import React, { useEffect, useState } from "react";
import Counselling from "./Counselling";
import Booking from "./Booking";
import "./Consult.css";

const Consult = ({ onRequestProcessed }) => {
  const [selectedTab, setSelectedTab] = useState(0);

  useEffect(() => {
    if (onRequestProcessed) {
      setSelectedTab(0);
    }
  }, [onRequestProcessed]);

  return (
    <div className="consult-wrapper">
      <div className="consult-container">
        <div className="tabs-container">
          <button
            className={`tab-button ${selectedTab === 0 ? "selected" : ""}`}
            onClick={() => setSelectedTab(0)}
          >
            <span
              className={`tab-text ${selectedTab === 0 ? "active-text" : ""}`}
            >
              Counselling
            </span>
          </button>
          <button
            className={`tab-button ${selectedTab === 1 ? "selected" : ""}`}
            onClick={() => setSelectedTab(1)}
          >
            <span
              className={`tab-text ${selectedTab === 1 ? "active-text" : ""}`}
            >
              Booking
            </span>
          </button>
        </div>

        <div className="content-container">
          {selectedTab === 0 ? <Counselling /> : <Booking />}
        </div>
      </div>
    </div>
  );
};

export default Consult;
